<template>

  <div class="studentPlatformWrapper"
       :class="FakeFeatureFlags.features.OLYMPICS_OVERLAY? 'background-color-olympic' : ''">
    <div class="colorDataObject" style="display: none">
      <div class="bb_color-01"></div>
    </div>

    <StudentPlatformBackground :schoolYear="buddyData.buddyConfig.grade"></StudentPlatformBackground>


    <div class="background">
      <BuddyPlatform :requiredBatteries="buddyData.expNextLevel"
                     :obtainedBatteries="buddyData.experience"
                     :animateNewBatteries="animateNewBatteries"
                     :levelUpReward="levelUpReward">
      </BuddyPlatform>
    </div>

    <StudentPlatformBackground :schoolYear="buddyData.buddyConfig.grade"
                               :isForeground="true"></StudentPlatformBackground>

    <div ref="buddyView" class=" buddyView">
      <div class="loadIconView">
        <div class="loadIcon" v-show="showLoadIcon">
          <LoadIcon :show="showLoadIcon"></LoadIcon>
        </div>
      </div>
      <div class="buddyCol">
        <div class="buddyContainer" ref="buddyContainer">
          <Buddy :showBuddy="showBuddy" :buddyData="buddyData" :buddyViewWidth="buddyViewWidth"
                 :buddyViewHeight="buddyViewHeight"
                 :containerSize="clientSize" :containerWidth="clientWidth" :containerHeight="clientHeight"
                 :shouldAnimate="buddyShouldAnimate"
                 v-on:buddyStartedLoading="buddyStartedLoading" v-on:buddyLoadingFinished="buddyLoadingFinished"
                 class="beweeg-buddy-window-0"
          ></Buddy>
        </div>
      </div>
    </div>

    <div class="buddyCustomisationOverlay" v-if="buddyData.buddyConfig.grade">
      <CustomisationWindow v-if="buddyData.colors && showBuddyCreation" :customisationType="'buddy'"
                           :selectedColors="buddyData.colors" :savingBuddy="savingBuddy" :buddy="buddyData"
                           v-on:itemClicked="itemClicked" v-on:removeItemClicked="removeItemClicked"
                           v-on:colorClicked="colorClicked"
                           v-on:closeClicked="customisationClosed"
                           v-on:confirmClicked="buddyCreationConfirmClicked"></CustomisationWindow>

      <CustomisationWindow v-show="buddyData.colors && !showBuddyCreation && showCustomisationWindow"
                           :showCustomisationWindow="showCustomisationWindow" :customisationType="'accessory'"
                           :selectedColors="buddyData.colors" :buddy="buddyData" :savingBuddy="savingBuddy"
                           :triggerFetch="triggerFirstAccessoryFetch" :levelUpReward="levelUpReward"
                           v-on:itemClicked="itemClicked" v-on:removeItemClicked="removeItemClicked"
                           v-on:colorClicked="colorClicked"
                           v-on:closeClicked="customisationClosed"
                           v-on:confirmClicked="customisationConfirmClicked"></CustomisationWindow>
    </div>

    <BuddyInfoOverlay :name="buddyData.name" :level="buddyData.level" :startedActivities="startedActivities"
                      :plannedActivities="plannedActivities"
                      :hideButtons="hideButtons"
                      v-on:clothesClicked="clothesClicked"
                      v-on:leaderboardClicked="leaderboardClicked"
                      v-on:activityButtonClicked="activityButtonClicked"
                      v-on:nextPlannedActivityClicked="nextPlannedActivityClicked"
                      v-on:notificationClicked="notificationClicked"></BuddyInfoOverlay>
  </div>

  <PhoneView v-show="showPhoneView" :name="openQuestTypeName" :open="showPhoneView" :buddyName="buddyData.name"
             v-on:closeClicked="closePhoneView" @showActivity="showSelectedActivity"></PhoneView>

  <Onboarding v-if="showOnboarding" :open="showOnboarding" :buddyCreationDone="buddyCreationDone" :buddy="buddyData"
              v-on:startBuddyCreation="startBuddyCreation" v-on:onboardingFinished="onboardingFinished"></Onboarding>

  <ActivitiesOverlay v-show="showActivitiesOverlay" :open="showActivitiesOverlay"
                     v-on:backClicked="activitiesOverlayBackClicked"
                     v-on:questClicked="questClicked" :buddy="buddyData"
                     :questType="openQuestTypeName" :currentActivities="activities"></ActivitiesOverlay>

  <ActivityDetailOverlay v-show="showActivityDetailOverlay" :open="showActivityDetailOverlay"
                         :activityId="selectedActivityId" :startedActivities="startedActivities"
                         :questType="openQuestTypeName" :showPlannedActivity="showPlannedActivity"
                         :showingRandomActivity="showingRandomActivity"
                         :showStartedActivity="showStartedActivity" :buddy="buddyData"
                         @backClicked="activityDetailOverlayBackClicked" @startActivityClicked="startActivityClicked"
                         @completeActivityClicked="completeActivityClicked"
                         @cancelActivityClicked="cancelActivityClicked"
                         @randomActivityClicked="questClicked"
                         @startPhoneView="startPhoneView"></ActivityDetailOverlay>

  <ImpulsePopup v-show="showImpulsePopup" :open="showImpulsePopup" :buddyId="buddyData.id"
                @closeClicked="showImpulsePopup = false" @randomActivityClicked="questClicked"
                @codeClicked="openImpulseCodeClicked"
                @openActivityListClicked="openImpulseActivityListClicked"></ImpulsePopup>

  <ImpulseCodeOverlay v-show="showImpulseCodeOverlay" :open="showImpulseCodeOverlay"
                      @closeClicked="impulseCodeOverlayCloseClicked"
                      @enterCodeClicked="enterCodeClicked"></ImpulseCodeOverlay>

  <RewardPopup v-show="levelUpReward !== null" :open="levelUpReward !== null" :levelUpReward="levelUpReward"
               :buddyData="buddyData"
               @closeClicked="closeRewardsClicked" @tryOnGadgetClicked="tryOnGadgetClicked"></RewardPopup>

  <LeaderboardOverlay v-if="showLeaderboard" v-show="showLeaderboard" :open="showLeaderboard"
                      :buddy="buddyData" @backClicked="closeLeaderboardClicked"></LeaderboardOverlay>

  <Confetti ref="confetti" :duration="4000" :amount="60"/>

</template>

<script>
import log from "@/utils/logger";
import anime from 'animejs';
import {BuddyApi, ActivityApi} from "sandpiper_api";
import {AID} from '@/enums/AccessoryIdEnum.js';
import AccessoryLibrary from "@/mixins/AccessoryLibrary";

import Buddy from "@/components/StudentPlatform/Buddy";
import CustomisationWindow from "@/components/StudentPlatform/Customisation/Buddy/CustomisationWindow";
import BuddyInfoOverlay from "@/components/StudentPlatform/BuddyInfoOverlay/BuddyInfoOverlay";
import BuddyPlatform from "@/components/StudentPlatform/BuddyPlatform";
import ActivitiesOverlay from "@/components/StudentPlatform/Activities/ActivitiesOverlay";
import ActivityDetailOverlay from "@/components/StudentPlatform/Activities/ActivityDetailOverlay";
import PhoneView from "@/components/StudentPlatform/PhoneView";
import Onboarding from "@/views/StudentViews/Onboarding/Onboarding";
import {MirrorParts} from "@/mixins/MirrorParts";
import ImpulsePopup from "@/components/StudentPlatform/ImpulsePopup";
import ImpulseCodeOverlay from "@/components/StudentPlatform/Activities/ImpulseCodeOverlay";
import RewardPopup from "@/components/StudentPlatform/RewardPopup";
import LoadIcon from "@/components/StudentPlatform/LoadIcon";
import FaviconManager from "@/mixins/FaviconManager";

import FakeFeatureFlags from "@/mixins/FakeFeatureFlags.js";
import {ActivityType} from "@/enums/ActivityType";
import SoundPlayer from "@/utils/SoundPlayer";
import {Sound} from "@/enums/Sound";
import StudentPlatformBackground from "@/views/StudentViews/StudentPlatformBackground.vue";
import Confetti from "@/components/Common/Confetti.vue";
import LeaderboardOverlay from "@/components/StudentPlatform/Leaderboard/LeaderboardOverlay.vue";

export default {
  name: "StudentPlatform",
  components: {
    LeaderboardOverlay,
    Confetti,
    StudentPlatformBackground,
    Buddy,
    CustomisationWindow,
    BuddyInfoOverlay,
    BuddyPlatform,
    ActivitiesOverlay,
    ActivityDetailOverlay,
    PhoneView,
    Onboarding,
    ImpulsePopup,
    ImpulseCodeOverlay,
    RewardPopup,
    LoadIcon
  },
  watch: {
    buddyData: {
      handler() {
        if (this.buddyData.bodyPartIds !== undefined && this.buddyData.bodyPartIds['head'] !== '') {
          //this.showLoadIcon = false;

          //mirror all body parts and accessories that need to be mirrored
          for (const part in MirrorParts) {
            if (part in this.buddyData.bodyPartIds) {
              if (this.buddyData.bodyPartIds[MirrorParts[part]] !== this.buddyData.bodyPartIds[part]) {
                this.buddyData.bodyPartIds[MirrorParts[part]] = this.buddyData.bodyPartIds[part];
              }
            }

            if (part in this.buddyData.accessoryIds) {
              if (this.buddyData.accessoryIds[MirrorParts[part]] !== this.buddyData.accessoryIds[part]) {
                this.buddyData.accessoryIds[MirrorParts[part]] = this.buddyData.accessoryIds[part];
              }
            }
          }

          let sleeve = AccessoryLibrary.getSleeveForShirtId(this.buddyData.accessoryIds[AID.SHIRT].name);
          if (sleeve && this.buddyData.accessoryIds['sleeve_left'].id !== sleeve.id) {
            this.buddyData.accessoryIds['sleeve_left'] = sleeve;
            this.buddyData.accessoryIds['sleeve_right'] = sleeve;
          } else if (!sleeve && this.buddyData.accessoryIds['sleeve_left'].id !== '') {
            this.buddyData.accessoryIds['sleeve_left'] = {name: '', id: ''};
            this.buddyData.accessoryIds['sleeve_right'] = {name: '', id: ''};
          }

        }
      },
      deep: true,
    },
    plannedActivities: {
      handler(newPlannedActivities, oldPlannedActivities) {
        if (newPlannedActivities.length > 0) {
          this.faviconManager.animateNotification();

          if (newPlannedActivities.length !== oldPlannedActivities.length) {
            SoundPlayer.playSound(Sound.NOTIFICATION);
          }

        } else {
          this.faviconManager.stopAnimating();
        }
      }
    },

  },
  inject: ["doApiRequest"],
  mixins: [FaviconManager],
  data() {
    return {
      FakeFeatureFlags: FakeFeatureFlags,
      buddyId: null,
      clientWidth: 0,
      clientHeight: 0,
      clientSize: {width: 0, height: 0},
      buddyViewWidth: 0,
      buddyViewHeight: 0,
      currentScreen: "home",
      savingBuddy: false,
      buddyFetched: false,
      openQuestTypeName: "",
      faviconManager: new FaviconManager(),
      showBuddy: false,
      showPhoneView: false,
      showActivitiesOverlay: false,
      showActivityDetailOverlay: false,
      showPlannedActivity: false,
      showStartedActivity: false,
      showOnboarding: false,
      showBuddyCreation: false,
      showCustomisationWindow: false,
      showImpulsePopup: false,
      showImpulseCodeOverlay: false,
      animateNewBatteries: false,
      showingRandomActivity: false,
      showLeaderboard: false,

      buddyCreationDone: false,
      selectedActivityId: null,
      firstTimeOpen: false,
      //hacky and bad.
      triggerFirstAccessoryFetch: false,

      debugTestOnboarding: false,
      ignoreUnfinishedBuddy: false,

      selectedQuestType: null,

      buddyData: {
        name: null,
        id: null,
        fitness: {
          posture: 0,
          colorVibrancy: 0,
          animation: 0,
        },
        avatar: null,
        buddyConfig: {
          className: '',
          school: {
            id: null,
            name: '',
            postalCode: '',
          },
          schoolYear: {
            endDate: null,
            startDate: null,
          },
          studentCount: null,
        },
        grade: null,
        expNextLevel: null,
        experience: null,
        level: null,
        bodyPartIds: {
          head: {name: 'head', id: ""},
          head_fuzz: {name: 'head_fuzz', id: ""},
          head_wrinkles: {name: 'head_wrinkles', id: ""},
          body_wrinkles: {name: 'body_wrinkles', id: ""},
          eyes: {name: 'eyes-01', id: ""},
          antenna: {name: 'antenna-01', id: ""},
          snout: {name: 'snout', id: ""},
          whiskers: {name: 'whiskers-05', id: ""},
          nose: {name: 'nose-01', id: ""},
          mouth: {name: 'mouth-01', id: ""},
          middle: {name: 'body', id: ""},
          ear_left: {name: 'ears-01', id: ""},
          ear_right: {name: 'ears-01', id: ""},
          arm_left: {name: 'arm', id: ""},
          arm_right: {name: 'arm', id: ""},
          leg_left: {name: 'leg', id: ""},
          leg_right: {name: 'leg', id: ""},
          eyebrow_left: {name: 'eyebrow', id: ""},
          eyebrow_right: {name: 'eyebrow', id: ""},
          tail: {name: 'tail', id: ""},
        },
        accessoryIds: {
          hat: {name: '', id: ""},
          shirt: {name: '', id: ""},
          sleeve_left: {name: '', id: ""},
          sleeve_right: {name: '', id: ""},
          shoe_left: {name: '', id: ""},
          shoe_right: {name: '', id: ""},
          hand: {name: '', id: ""},
          pants: {name: '', id: ""},
        },
        colors: {
          buddy_primary: '',
          buddy_secondary: '',
          buddy_tertiary: '',
          accessory_primary: '',
          accessory_secondary: '',
          accessory_tertiary: '',
        }
      },
      oldBuddyData: {
        name: '',
        //buddyId is used when multiple buddies need to be shown on screen. Should be 0 if just one.
        buddyId: 0,
        createdDate: null,
        bodyPartIds: {
          head: '',
          eyes: '',
          antenna: '',
          snout: '',
          nose: '',
          mouth: '',
          middle: '',
          ear_left: '',
          ear_right: '',
          arm_left: '',
          arm_right: '',
          leg_left: '',
          leg_right: '',
          eyebrow_left: '',
          eyebrow_right: '',
          tail: '',
        },
        accessoryIds: {
          hat: '',
          shirt: '',
          sleeve_left: '',
          sleeve_right: '',
          shoe_left: '',
          shoe_right: '',
          hand: '',
          pants: '',
        },
        colors: {
          buddy_primary: '',
          buddy_secondary: '',
          buddy_tertiary: '',
          accessory_primary: '',
          accessory_secondary: '',
          accessory_tertiary: '',
        }
      },

      activities: [],
      startedActivities: [],
      plannedActivities: [],
      levelUpReward: null,
      showLoadIcon: true,

      activityGetInterval: null,
    }
  },
  methods:
      {
        handleResize() {
          if (this.$refs.buddyContainer) {
            this.clientWidth = this.$refs.buddyContainer.clientWidth;
            this.clientHeight = this.$refs.buddyContainer.clientHeight;
            this.clientSize = [this.clientWidth, this.clientHeight];
            this.buddyViewWidth = this.$refs.buddyView.clientWidth;
            this.buddyViewHeight = this.$refs.buddyView.clientHeight;
          }
        },


        //#region Customisation
        itemClicked(data) {

          if (data.kind === 'body') {
            this.buddyData.bodyPartIds = Object.assign({}, this.buddyData.bodyPartIds, {[data.type]: data});
          }

          if (data.kind === 'accessory') {
            this.buddyData.accessoryIds = Object.assign({}, this.buddyData.accessoryIds, {[data.type]: data});
          }

        },

        removeItemClicked(id) {
          this.buddyData.accessoryIds[id] = {name: '', id: ''};

          if (MirrorParts[id]) {
            let mirroredPartType = MirrorParts[id];
            this.buddyData.accessoryIds = Object.assign({}, this.buddyData.accessoryIds, {
              [mirroredPartType]: {
                name: '',
                id: ''
              }
            });
          }
        },

        colorClicked(data) {
          if (data.kind === 'buddy') {
            switch (data.id) {
              case 0:
                this.buddyData.colors.buddy_primary = data.color;
                break;
              case 1:
                this.buddyData.colors.buddy_secondary = data.color;
                break;
              case 2:
                this.buddyData.colors.buddy_tertiary = data.color;
                break;
            }
          }

          if (data.kind === 'accessory') {
            switch (data.id) {
              case 0:
                this.buddyData.colors.accessory_primary = data.color;
                break;
              case 1:
                this.buddyData.colors.accessory_secondary = data.color;
                break;
              case 2:
                this.buddyData.colors.accessory_tertiary = data.color;
                break;
            }
          }

        },

        async customisationConfirmClicked() {
          await this.sendBuddyChangesToServer("update");
          this.triggerFirstAccessoryFetch = true;
          this.moveToMain();
        },

        async buddyCreationConfirmClicked() {
          //await this.sendBuddyChangesToServer();
          //this.moveToMain();

          this.showOnboarding = true;
          this.buddyCreationDone = true;
        },

        customisationClosed() {

          //revert buddy changes
          //Object.assign(this.buddyData.accessoryIds, this.oldBuddyData.accessoryIds);
          //this.buddyData.accessoryIds = this.oldBuddyData.accessoryIds;
          this.buddyData = Object.assign({}, this.oldBuddyData);
          this.showCustomisationWindow = false;
          this.moveToMain();
        },

        clothesClicked() {
          //backup buddy to oldBuddyData in case we want to revert the changes
          //this.oldBuddyData = Object.assign({}, this.buddyData);
          //deep clone of buddy in case we want to revert the changes
          this.oldBuddyData = JSON.parse(JSON.stringify(this.buddyData));

          this.currentScreen = 'customisation';
          this.showCustomisationWindow = true;
          this.moveToCustomisation();
        },

        leaderboardClicked() {
          this.showLeaderboard = true;
        },

        async sendBuddyChangesToServer(type) {
          if (this.savingBuddy) return;

          try {
            this.savingBuddy = true;

            let newBuddyData = this.buddyData;

            newBuddyData.body = {
              'antennas': {
                id: newBuddyData.bodyPartIds['antenna'].id,
                name: newBuddyData.bodyPartIds['antenna'].name
              },
              'eyes': {id: newBuddyData.bodyPartIds['eyes'].id, name: newBuddyData.bodyPartIds['eyes'].name},
              'mouth': {id: newBuddyData.bodyPartIds['mouth'].id, name: newBuddyData.bodyPartIds['mouth'].name},
              'nose': {id: newBuddyData.bodyPartIds['nose'].id, name: newBuddyData.bodyPartIds['nose'].name},
              'ears': {id: newBuddyData.bodyPartIds['ear_left'].id, name: newBuddyData.bodyPartIds['ear_left'].name},
              'markings': {
                id: newBuddyData.bodyPartIds['whiskers'].id,
                name: newBuddyData.bodyPartIds['whiskers'].name
              },
              'skinColor': {
                primary: newBuddyData.colors.buddy_primary,
                secondary: newBuddyData.colors.buddy_secondary,
                tertiary: newBuddyData.colors.buddy_tertiary,
              },
            }

            newBuddyData.outfit = {
              accessory: newBuddyData.accessoryIds["hand"].id !== "" ? {
                id: newBuddyData.accessoryIds["hand"].id,
                type: "accessory"
              } : null,
              head: newBuddyData.accessoryIds["hat"].id !== "" ? {
                id: newBuddyData.accessoryIds["hat"].id,
                type: "head"
              } : null,
              legs: newBuddyData.accessoryIds["pants"].id !== "" ? {
                id: newBuddyData.accessoryIds["pants"].id,
                type: "legs"
              } : null,
              chest: newBuddyData.accessoryIds["shirt"].id !== "" ? {
                id: newBuddyData.accessoryIds["shirt"].id,
                type: "chest"
              } : null,
              feet: newBuddyData.accessoryIds["shoe_left"].id !== "" ? {
                id: newBuddyData.accessoryIds["shoe_left"].id,
                type: "feet"
              } : null,
              colors: {
                primary: newBuddyData.colors.accessory_primary,
                secondary: newBuddyData.colors.accessory_secondary,
                tertiary: newBuddyData.colors.accessory_tertiary,
              },
            }

            if (type !== "update") {
              await this.doApiRequest(() => new BuddyApi().initializeBuddy(newBuddyData.id, newBuddyData));
            } else {
              await this.doApiRequest(() => new BuddyApi().updateBuddyOutfit(newBuddyData.id, newBuddyData.outfit));
            }
          } catch (e) {
            // TODO - handle error
          } finally {
            this.savingBuddy = false;
          }
        },


        //#endregion

        //#region Buddy
        buddyStartedLoading() {
          //console.log("buddy started loading");
          this.showLoadIcon = true;
        },

        buddyLoadingFinished() {
          //console.log("buddy stopped loading")
          this.showLoadIcon = false;

          if ((this.buddyData.name == null || this.debugTestOnboarding) && this.showBuddyCreation === false && !this.ignoreUnfinishedBuddy) {
            this.firstTimeOpen = true;
            this.currentScreen = 'onboarding';
            this.showOnboarding = true;

            //todo: remove
            this.debugTestOnboarding = false;
          }
        },

        startBuddyCreation() {
          this.showBuddyCreation = true;
          this.showOnboarding = false;
          this.currentScreen = 'customisation';
          this.moveToCustomisation();
        },

        onboardingFinished(newName) {
          this.showOnboarding = false;
          this.showBuddyCreation = false;
          this.buddyCreationDone = false;

          this.buddyData.name = newName;

          this.sendBuddyChangesToServer();
          this.moveToMain();
        },

        //#endregion

        activityButtonClicked(data) {
          this.openQuestTypeName = data;

          if (data === ActivityType.IMPULSE) {
            this.showImpulsePopup = true;
          } else {
            this.showActivitiesOverlay = true;
          }
        },

        openImpulseActivityListClicked() {
          this.openQuestTypeName = ActivityType.IMPULSE;
          this.showImpulsePopup = false;
          this.showActivitiesOverlay = true;
        },

        nextPlannedActivityClicked(data) {
          this.startPhoneView(data.id, "planned");
        },

        notificationClicked(name) {
          console.log(name)
          this.openQuestTypeName = name;
          this.showActivityDetailOverlay = true;
          this.showStartedActivity = true;
        },

        openImpulseCodeClicked() {
          this.showImpulsePopup = false;
          this.showImpulseCodeOverlay = true;
        },

        //Todo: Every component should be responsible for it's own animation, don't animate BuddyPlatform here.
        moveToCustomisation() {
          this.currentScreen = "customisation";
          let bgWidth = document.querySelector('.background>.top').clientWidth;

          let moveToCustomisationAnimation = anime.timeline({
            easing: 'easeOutExpo',
            duration: 750,
            loop: false,
          });

          moveToCustomisationAnimation.add({
            targets: '.background>.top',
            translateX: [0, (-bgWidth / 40)],
            easing: 'linear'
          });

          moveToCustomisationAnimation.add({
            targets: '.background>.bottom',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

          moveToCustomisationAnimation.add({
            targets: '.background>.platform',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

          moveToCustomisationAnimation.add({
            targets: '.background>.decorations',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

          moveToCustomisationAnimation.add({
            targets: '.buddyView',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

          moveToCustomisationAnimation.add({
            targets: '.buddyOverlay',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

          moveToCustomisationAnimation.add({
            targets: '.buddyCustomisationOverlay',
            translateX: 0,
            easing: 'linear'
          }, 0);
        },

        moveToMain() {
          this.currentScreen = "home";
          let bgWidth = document.querySelector('.background>.top').clientWidth;

          let moveToMainAnimation = anime.timeline({
            easing: 'easeOutExpo',
            duration: 750,
            loop: false,
          });

          moveToMainAnimation.add({
            targets: '.background>.top',
            translateX: 0,
            easing: 'linear'
          });

          moveToMainAnimation.add({
            targets: '.background>.bottom',
            translateX: 0,
            easing: 'linear'
          }, 0);

          moveToMainAnimation.add({
            targets: '.background>.platform',
            translateX: 0,
            easing: 'linear'
          }, 0);

          moveToMainAnimation.add({
            targets: '.background>.decorations',
            translateX: 0,
            easing: 'linear'
          }, 0);

          moveToMainAnimation.add({
            targets: '.buddyView',
            translateX: 0,
            easing: 'linear'
          }, 0);

          moveToMainAnimation.add({
            targets: '.buddyOverlay',
            translateX: 0,
            easing: 'linear'
          }, 0);

          moveToMainAnimation.add({
            targets: '.buddyCustomisationOverlay',
            translateX: bgWidth,
            easing: 'linear'
          }, 0);
        },

        moveToRewards() {
          let bgWidth = document.querySelector('.background>.top').clientWidth;

          let moveToCustomisationAnimation = anime.timeline({
            easing: 'easeOutExpo',
            duration: 750,
            loop: false,
          });

          moveToCustomisationAnimation.add({
            targets: '.background>.top',
            translateX: [0, (-bgWidth / 40)],
            easing: 'linear'
          });

          moveToCustomisationAnimation.add({
            targets: '.background>.bottom',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

          moveToCustomisationAnimation.add({
            targets: '.background>.platform',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

          moveToCustomisationAnimation.add({
            targets: '.background>.decorations',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

          moveToCustomisationAnimation.add({
            targets: '.buddyView',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

          moveToCustomisationAnimation.add({
            targets: '.buddyOverlay',
            translateX: [0, (-bgWidth / 5)],
            easing: 'linear'
          }, 0);

        },

        //#region Activities

        findActivityButtonClicked(questType) {
          this.selectedQuestType = questType;
          this.showActivitiesOverlay = true;
        },

        activitiesOverlayBackClicked(fromImpulseActivityContent) {
          this.showActivitiesOverlay = false;
          this.showImpulsePopup = fromImpulseActivityContent;
        },

        activityDetailOverlayBackClicked(fromImpulseActivityContent) {
          this.showActivityDetailOverlay = false;
          this.showPlannedActivity = false;
          this.showStartedActivity = false;
          this.showPhoneView = false;
          this.showActivitiesOverlay = !fromImpulseActivityContent;
          this.showImpulsePopup = fromImpulseActivityContent;
        },

        questClicked(id, isRandom) {
          console.log("activity Clicked id:" + id)
          this.selectedActivityId = id;
          this.showActivitiesOverlay = false;
          this.showImpulsePopup = false;
          this.showImpulseCodeOverlay = false;
          this.showActivityDetailOverlay = false;

          this.$nextTick(function () {
            this.showActivityDetailOverlay = true;
            this.showingRandomActivity = isRandom;
          });
        },

        startPhoneView(id) {
          let that = this;
          that.selectedActivityId = id;
          that.showActivityDetailOverlay = false;
          that.showActivitiesOverlay = false;
          //if (that.shouldShowPhone(source)) {
          // that.showPhoneView = true;
          //that.increasePhoneViewCount();
          // } else {
            this.$nextTick(function () {
              that.showSelectedActivity();
            });
          //}
        },

        increasePhoneViewCount() {
          let phoneShowCount = localStorage.getItem("phoneShowCount");
          if (localStorage.getItem("phoneShowCount") === null) {
            phoneShowCount = 0;
          }
          phoneShowCount++;
          localStorage.setItem("phoneShowCount", phoneShowCount);
        },

        shouldShowPhone(source) {

          //if activity was started manually
          if (source === "detailOverlay") {
            return false;
          }

          let phoneShowCount = localStorage.getItem("phoneShowCount");
          if (phoneShowCount === null || phoneShowCount <= 2) {
            return true;
          } else return Math.random() < 0.33;

        },

        startActivityClicked(data) {
          console.log("start activity clicked for activity " + data.id);

          let result = this.sendStartActivity(data.id).then(() => {
            this.openQuestTypeName = data.questTypeName;
            this.showActivityDetailOverlay = true;
            this.showStartedActivity = true;
            this.showPlannedActivity = false;

          });

          log.info(result);
        },

        completeActivityClicked(data) {
          log.info("complete activity clicked for activity " + data.activityId);
          log.info(data);
          this.sendCompleteActivity(data).then((result) => {
            log.info(result);
            SoundPlayer.stopMusic();
            //SoundPlayer.playSound(Sound.APPLAUSE)
            
            this.applyBuddyData(result.buddy);

            if (result.levelUpReward != undefined) {
              result.levelUpReward.points = data.activity.quest.points;

              if (result.hasLeveled) {
                result.levelUpReward.level = result.buddy.level;
                this.triggerConfetti();
              }

              this.levelUpReward = result.levelUpReward;
            } else {

              this.levelUpReward = {
                points: data.activity.quest.points,
                level: result.hasLeveled ? result.buddy.level : null
              };
            }

            this.moveToRewards();
            this.currentScreen = "rewards";

            this.animateNewBatteries = true;
            this.showActivityDetailOverlay = false;
            this.showStartedActivity = false;
            this.showPlannedActivity = false;
            this.showImpulseCodeOverlay = false;

          });
        },

        async enterCodeClicked(quest) {

          let activity = {
            buddy: this.buddyData,
            plannedDate: new Date(),
            quest: quest,
          }

          let result = await this.doApiRequest(() => new ActivityApi().createActivity(activity));

          this.sendStartActivity(result.id).then(() => {
            let data = {
              activityId: result.id,
              activity: result,
              results: [],
            };
            this.completeActivityClicked(data);
          });

        },

        cancelActivityClicked(id) {
          console.log("cancel activity clicked for activity " + id);
          this.sendCancelActivity(id).then(() => {
            this.showActivityDetailOverlay = false;
            this.showPlannedActivity = false;
            this.showStartedActivity = false;
          });
        },

        showSelectedActivity() {
          this.showActivityDetailOverlay = true;
          this.showPlannedActivity = true;
          this.showPhoneView = false;
          //SoundPlayer.playSound(Sound.ACTIVITYSTARTED);
        },

        closeImpulsePopupClicked() {
          this.showImpulsePopup = false;
        },

        impulseCodeOverlayCloseClicked() {
          this.showImpulseCodeOverlay = false;
          this.showImpulsePopup = true;
        },

        //#endregion

        //#region PhoneView

        closePhoneView() {
          this.showPhoneView = false;
        },

        closeRewardsClicked() {
          this.levelUpReward = null;
          this.moveToMain();
          //this.stopAnimatingBatteries();
          this.animateNewBatteries = false;
        },

        tryOnGadgetClicked() {
          this.levelUpReward = null;
          this.animateNewBatteries = false;
          this.currentScreen = 'customisation';
          this.showCustomisationWindow = true;
          this.oldBuddyData = JSON.parse(JSON.stringify(this.buddyData));
          this.moveToCustomisation();
        },

        //#endregion


        triggerConfetti() {
          this.$refs.confetti.start()
        },
        
        hideLoadIcon() {
          this.showLoadIcon = false;
        },

        //Todo: move all fetches to separate mixin to make BuddyDevTest a bit less crazy

        async fetchAllBuddies() {
          if (this.fetchingAllBuddies) return;

          try {
            this.fetchingAllBuddies = true;

            let buddies = await this.doApiRequest(() => new BuddyApi().getBuddies());
            //this.applyBuddyData(buddies);
            return buddies;

          } catch (e) {
            // TODO - handle error
            console.log(e);
            return null;
          } finally {
            this.fetchingAllBuddies = false;
          }
        },

        async fetchBuddy() {
          if (this.fetchingBuddy) return;

          try {
            this.fetchingBuddy = true;

            //eventually the getBuddy will
            console.log("fetching buddy with id " + this.buddyId)
            let buddyInfo = await this.doApiRequest(() => new BuddyApi().getBuddy(this.buddyId));
            this.applyBuddyData(buddyInfo);

            //const waitFor = delay => new Promise(resolve => setTimeout(resolve, delay));
            //await waitFor(process.env.VUE_APP_ENV_FAKE_SERVER_DELAY);
            //this.buddyData = this.tempBuddy;

            console.log(this.buddyData);

            if (this.buddyData.createdDate == null) {
              //this.buddyData = this.tempBuddy;
            } else {
              //this.buddyData = this.tempBuddy;
            }
          } catch (e) {
            console.log(e);

            await this.$router.push({
              name: "agenda"
            });
          } finally {
            this.fetchingBuddy = false;
          }
        },

        async fetchActivities() {
          if (this.fetchingActivities) return;

          try {
            this.fetchingActivities = true;

            let activities = await this.doApiRequest(() => new ActivityApi().getCurrentActivitiesForBuddy(this.buddyData.id));

            this.startedActivities = this.filterStartedActivities(activities);
            this.plannedActivities = this.filterPlannedActivities(activities);

          } catch (e) {
            // TODO - handle error
            console.log(e);
          } finally {
            this.fetchingActivities = false;
          }
        },

        //all activities that had a planned date < now, and have been started
        filterStartedActivities(activities) {
          return activities.filter(act => act.startedDate !== null);
        },

        //all activities that had a planned date < now, and have not been started
        filterPlannedActivities(activities) {
          return activities.filter(act => act.startedDate === null);
        },


        //TODO (lm): clean up, should eventually just use the data provided
        applyBuddyData(data) {
          let bodyPartIds = {
            'antennas': 'antenna',
            'eyes': 'eyes',
            'mouth': 'mouth',
            'nose': 'nose',
            'ears': 'ear_left',
            'markings': 'whiskers',
          }

          let accessoryIds = {
            accessory: "hand",
            head: "hat",
            legs: "pants",
            chest: "shirt",
            feet: "shoe_left",
          }

          for (const [key, value] of Object.entries(data)) {
            if (value !== undefined) {
              if (key === 'body') {
                for (const [key, value] of Object.entries(data.body)) {
                  if (value !== undefined) {
                    this.buddyData.bodyPartIds[bodyPartIds[key]] = value;

                  }
                }
              } else if (key === 'outfit') {
                for (const [key, value] of Object.entries(data.outfit)) {
                  if (value !== undefined) {
                    this.buddyData.accessoryIds[accessoryIds[key]] = value;

                  }
                }
              } else {
                if (this.buddyData[key] !== undefined) {
                  this.buddyData[key] = value;
                }
              }
            }
          }

          if (data.body.skinColor !== undefined) {
            this.buddyData.colors.buddy_primary = data.body.skinColor.primary;
            this.buddyData.colors.buddy_secondary = data.body.skinColor.secondary;
            this.buddyData.colors.buddy_tertiary = data.body.skinColor.tertiary;
          }


          if (data.outfit.colors !== undefined) {
            this.buddyData.colors.accessory_primary = data.outfit.colors.primary !== "" ? data.outfit.colors.primary : "rgb(155,171,209)";
            this.buddyData.colors.accessory_secondary = data.outfit.colors.secondary !== "" ? data.outfit.colors.secondary : "rgb(239,209,25)";
            this.buddyData.colors.accessory_tertiary = data.outfit.colors.tertiary !== "" ? data.outfit.colors.tertiary : "rgb(243,238,238)";
          } else {
            this.buddyData.colors.accessory_primary = "rgb(155,171,209)";
            this.buddyData.colors.accessory_secondary = "rgb(239,209,25)";
            this.buddyData.colors.accessory_tertiary = "rgb(243,238,238)";
          }

          console.log(data);

        },

        async sendStartActivity(id) {
          if (this.startingActivity) return;

          try {
            this.startingActivity = true;

            let result = await this.doApiRequest(() => new ActivityApi().startActivity(id));
            console.log(result);


          } catch (e) {
            // TODO - handle error
            console.log(e);
          } finally {
            this.startingActivity = false;

            //get updated list of activities
            await this.fetchActivities();
          }
        },

        async sendCompleteActivity(data) {
          if (this.completingActivity) return;

          try {
            this.completingActivity = true;

            let result = await this.doApiRequest(() => new ActivityApi().completeActivity(data.activityId, data));
            return (result);

          } catch (e) {
            // TODO - handle error
            console.log(e);
          } finally {
            this.completingActivity = false;

            //get updated list of activities
            await this.fetchActivities();
          }
        },

        async sendCancelActivity(id) {
          if (this.cancellingActivity) return;

          try {
            this.cancellingActivity = true;

            console.log("cancelling activity with id " + id)
            let result = await this.doApiRequest(() => new ActivityApi().cancelActivity(id));
            console.log(result);

          } catch (e) {
            // TODO - handle error
            console.log(e);
          } finally {
            this.cancellingActivity = false;

            //get updated list of activities
            await this.fetchActivities();
          }
        },

        //this is kind of simple
        getActivitiesPeriodically() {
          this.activityGetInterval = setInterval(this.fetchActivities, 30000);
        },

        closeLeaderboardClicked() {
          this.showLeaderboard = false;
        }

      },
  computed: {
    hideButtons() {
      return (this.currentScreen !== "home");
    },
    buddyShouldAnimate() {
      if (this.showActivitiesOverlay || this.showActivityDetailOverlay) {
        return false;
      } else {
        return true;
      }
    },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize)
    this.$nextTick(function () {
      this.handleResize();
    });

    if (this.$route.params.id) {
      this.buddyId = this.$route.params.id;
    } else {
      let buddies = await this.fetchAllBuddies();
      this.buddyId = buddies[0].id;
    }

    await this.fetchBuddy();
    await this.fetchActivities();

    this.buddyFetched = true;
    this.showBuddy = true;


    this.moveToMain();

    this.getActivitiesPeriodically();

    //SoundPlayer.playSound(Sound.INTROSOUND);


  },
  beforeUnmount: function () {
    window.removeEventListener('resize', this.handleResize);
    clearInterval(this.activityGetInterval);
  },
  async created() {


  },
}
</script>

<style lang="scss" scoped>

@mixin aspect-ratio($width, $height) {
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ($height / $width) * 100%;
  }
  > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.flex-fill {
  overflow: hidden;
}

.studentPlatformWrapper {
  width: 100%;
  height: 100%;
  background-color: rgb(206, 233, 212);
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;


  //height: calc(100vw * 0.5625);
}

.background-color-olympic {
  //background-color: rgb(176,77,67);
}

.background {
  width: 100%;
  height: min(100vh, calc(100vw * 0.5625));

  position: absolute;
  overflow: hidden;
  will-change: transform;
  pointer-events: none;

  .top, .bottom, {
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .platform {
    position: relative;
    background-repeat: no-repeat;
    background-size: contain;
    pointer-events: all !important;
  }

  .top {
    width: 120%;
    height: 80%;
    background-position: center;
    left: -10%;
  }

  .background-image-top {
    background-image: url("~@/assets/image/background/bb_background.svg");
  }

  .background-image-top-olympic {
    background-image: url("~@/assets/image/background/bb_background_olympic.svg");
    position: absolute !important;
  }

  .bottom {
    width: 150%;
    height: 36%;
    background-position: 50%;
    left: -25%;
    background-repeat: repeat-x;
  }

  .background-image-bottom {
    background-image: url("~@/assets/image/background/bb_floor.svg");
  }

  .background-image-bottom-olympic {
    background-image: url("~@/assets/image/background/bb_floor_olympic.svg");
    height: 73% !important;
    top: 42% !important;
    position: absolute !important;
  }

}


.container {
  height: 100%;
}

.buddyContainer {
  width: 100%;
  height: min(100vh, calc(100vw * 0.5625));
  //height: calc(100vh - 75px - 50px);
}

.buddyCol {
  margin-left: 20%;
  margin-right: 20%;
  max-width: 60%;
}

.buddyView {
  //height: 100%;
  width: 100%;
  height: min(100vh, calc(100vw * 0.5625));
  overflow: hidden;
  position: relative;
  left: 0%;
  top: calc(6vw);
  will-change: transform;
  pointer-events: none;
}

.buddyOverlay, .buddyCustomisationOverlay {
  //height: calc(100vh - 75px - 50px);
  width: 100%;
  height: min(100vh, calc(100vw * 0.5625));

  //overflow: hidden;
  position: absolute;
  top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  will-change: transform;

  .top-bar {
    height: 15%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;

    .home-button {
      width: 10%;
    }

    .buddy-name-bar {
      width: 40%;
      display: flex;
      justify-content: center;
      align-items: center;

    }
  }

  .buttons {
    display: flex;
    height: 85%;

    .buttons-left, .buttons-right {
      height: 100%;
      width: 26%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 8%;
      padding-top: 3%;

      .activity-button {
        background-color: red;
      }
    }

    .center {
      height: 100%;
      width: 68%;
    }
  }
}

.loadIconView {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .loadIcon {
    width: 100px;
    height: 100px;
    position: relative;
    z-index: 999;


  }
}


</style>